import React from 'react';
import {
  Avatar,
  Box,
  ButtonBase,
  Drawer,
  Typography,
} from '@mui/material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import HotelOutlinedIcon from '@mui/icons-material/HotelOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { getNativeDrawerPortalProps } from '../../../utils/mobileView';
import {
  getMobileShellMenuItemIconSx,
  getMobileShellMenuItemLabelSx,
  getMobileShellMenuItemSx,
  getMobileShellMenuItemSubtitleSx,
  getMobileShellMenuListSx,
  getMobileShellMenuUserAvatarSx,
  getMobileShellMenuUserCardSx,
  getMobileShellMenuUserEmailSx,
  getMobileShellMenuUserNameSx,
  getMobileShellSheetBackdropSx,
  getMobileShellSheetHandleSx,
  getMobileShellSheetHeaderSx,
  getMobileShellSheetPaperSx,
} from '../../../utils/mobileShellMenuLayout';

function MenuAction({
  icon: Icon,
  label,
  subtitle,
  onClick,
  danger = false,
}) {
  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onClick?.(event);
  };

  return (
    <ButtonBase
      component="button"
      type="button"
      onClick={handleClick}
      focusRipple
      sx={{
        ...getMobileShellMenuItemSx({ danger }),
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-start',
        textAlign: 'left',
      }}
    >
      <Box sx={getMobileShellMenuItemIconSx({ danger })}>
        <Icon sx={{ fontSize: 21 }} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
        <Typography sx={getMobileShellMenuItemLabelSx(danger)}>{label}</Typography>
        {subtitle ? (
          <Typography sx={getMobileShellMenuItemSubtitleSx(danger)}>{subtitle}</Typography>
        ) : null}
      </Box>
      <ChevronRightRoundedIcon
        sx={{
          color: danger ? 'rgba(254,202,202,0.55)' : 'rgba(148,163,184,0.55)',
          fontSize: 22,
          flexShrink: 0,
        }}
      />
    </ButtonBase>
  );
}

export default function MobileProfileMenuSheet({
  open,
  onClose,
  user,
  onMyProfile,
  onSwitchHotel,
  onLockScreen,
  onLogout,
}) {
  const displayName = user?.fullName || user?.username || 'User';
  const initial = displayName[0]?.toUpperCase() || 'U';

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      {...getNativeDrawerPortalProps()}
      ModalProps={{ keepMounted: true }}
      PaperProps={{ sx: getMobileShellSheetPaperSx('min(78vh, 560px)') }}
      slotProps={{ backdrop: { sx: getMobileShellSheetBackdropSx() } }}
      sx={{ zIndex: 1700 }}
    >
      <Box sx={getMobileShellSheetHandleSx()} />

      <Box sx={getMobileShellSheetHeaderSx()}>
        <Typography component="h2">Account</Typography>
        <AccountCircleOutlinedIcon sx={{ fontSize: 22, opacity: 0.55 }} />
      </Box>

      <Box sx={getMobileShellMenuUserCardSx()}>
        <Avatar sx={getMobileShellMenuUserAvatarSx()}>{initial}</Avatar>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography sx={getMobileShellMenuUserNameSx()}>{displayName}</Typography>
          {user?.email ? (
            <Typography sx={getMobileShellMenuUserEmailSx()}>{user.email}</Typography>
          ) : null}
        </Box>
      </Box>

      <Box sx={getMobileShellMenuListSx()} role="menu" aria-label="Profile actions">
        <MenuAction
          icon={PersonOutlineIcon}
          label="My Profile"
          subtitle="View and edit your account"
          onClick={onMyProfile}
        />
        <MenuAction
          icon={HotelOutlinedIcon}
          label="Switch Hotel"
          subtitle="Change active property"
          onClick={onSwitchHotel}
        />
        <MenuAction
          icon={LockOutlinedIcon}
          label="Lock Screen"
          subtitle="Pause session on this device"
          onClick={onLockScreen}
        />
        <MenuAction
          icon={LogoutOutlinedIcon}
          label="Log Out"
          subtitle="Sign out of RoomNexa"
          onClick={onLogout}
          danger
        />
      </Box>
    </Drawer>
  );
}
